export function configureCapacitorDocumentBase(runtimeConfig, documentRef) {
  if (!runtimeConfig?.capacitorApp || !documentRef?.head) {
    return '';
  }
  const assetOrigin = documentRef.defaultView?.location?.origin || globalThis.location?.origin || '';
  if (!assetOrigin) return '';
  let base = documentRef.querySelector('base[data-jc-capacitor-base]');
  if (!base) {
    base = documentRef.createElement('base');
    base.dataset.jcCapacitorBase = 'true';
    documentRef.head.prepend(base);
  }
  base.href = `${String(assetOrigin).replace(/\/$/, '')}/`;
  return base.href;
}
